/* ISO Diamant — Kit builder
   Ogni fresa ha il suo "Aggiungi al carrello" (property _iso_single) con toast di conferma.
   La barra mostra il totale delle singole nel carrello e le soglie €150 (kit) / €300 (sped. gratis).
   Il checkout sotto €150 resta bloccato da iso-cart-guard.js. */
(function () {
  'use strict';

  function money(cents) {
    return (cents / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
  }

  function init(root) {
    var cfg = {
      collection: root.dataset.collection,
      min: parseInt(root.dataset.min, 10) || 15000,
      freeShip: parseInt(root.dataset.freeShip, 10) || 30000,
      f1: root.dataset.filter1 || 'Diametro',
      f2: root.dataset.filter2 || 'Grana',
      cartUrl: root.dataset.cartUrl || '/cart'
    };

    var grid = root.querySelector('[data-kb-grid]');
    var totalEl = root.querySelector('[data-kb-total]');
    var countEl = root.querySelector('[data-kb-count]');
    var fillEl = root.querySelector('[data-kb-fill]');
    var markMin = root.querySelector('[data-kb-mark-min]');
    var hintEl = root.querySelector('[data-kb-hint]');
    var goBtn = root.querySelector('[data-kb-add]');
    var searchEl = root.querySelector('[data-kb-search]');
    var filter1El = root.querySelector('[data-kb-filter1]');
    var filter2El = root.querySelector('[data-kb-filter2]');

    var products = [];
    var cartItems = [];
    var cartSingles = 0;
    var refreshers = [];

    if (markMin) markMin.style.left = Math.round((cfg.min / cfg.freeShip) * 100) + '%';

    var toastEl = document.createElement('div');
    toastEl.className = 'iso-kb__toast';
    toastEl.setAttribute('role', 'status');
    root.appendChild(toastEl);
    var toastTimer;
    function toast(msg) {
      toastEl.textContent = msg;
      toastEl.classList.add('is-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2600);
    }

    function fetchCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          cartItems = cart.items || [];
          cartSingles = 0;
          cartItems.forEach(function (it) {
            if (it.properties && it.properties._iso_single) {
              cartSingles += it.final_line_price != null ? it.final_line_price : it.line_price;
            }
          });
          updateBar();
          refreshers.forEach(function (f) { f(); });
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (b) {
            b.textContent = cart.item_count;
          });
          if (!document.querySelector('.cart-count-bubble') && cart.item_count > 0) {
            var icon = document.querySelector('#cart-icon-bubble');
            if (icon) {
              var div = document.createElement('div');
              div.className = 'cart-count-bubble';
              div.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
              icon.appendChild(div);
            }
          }
          document.dispatchEvent(new CustomEvent('iso:cart-updated', { detail: cart }));
          return cart;
        })
        .catch(function () {});
    }

    fetch('/collections/' + cfg.collection + '/products.json?limit=250')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        products = (data.products || []).filter(function (p) { return p.variants && p.variants.length; });
        buildFilters();
        render();
        fetchCart();
      })
      .catch(function () {
        grid.innerHTML = '<div class="iso-kb__empty">Impossibile caricare le frese in questo momento.<br>Verifica che la collezione «' + cfg.collection + '» esista, oppure riprova più tardi.</div>';
      });

    function optIndex(p, name) {
      if (!p.options) return -1;
      for (var i = 0; i < p.options.length; i++) {
        var n = typeof p.options[i] === 'string' ? p.options[i] : p.options[i].name;
        if (n && n.toLowerCase() === name.toLowerCase()) return i;
      }
      return -1;
    }

    function buildFilters() {
      var v1 = {}, v2 = {};
      products.forEach(function (p) {
        var i1 = optIndex(p, cfg.f1);
        var i2 = optIndex(p, cfg.f2);
        p.variants.forEach(function (v) {
          if (i1 > -1 && v['option' + (i1 + 1)]) v1[v['option' + (i1 + 1)]] = true;
          if (i2 > -1 && v['option' + (i2 + 1)]) v2[v['option' + (i2 + 1)]] = true;
        });
      });
      fillSelect(filter1El, Object.keys(v1));
      fillSelect(filter2El, Object.keys(v2));
    }

    function fillSelect(sel, values) {
      if (!sel) return;
      values.sort(function (a, b) { return a.localeCompare(b, 'it', { numeric: true }); });
      values.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        sel.appendChild(o);
      });
    }

    function matches(p) {
      var q = (searchEl && searchEl.value || '').trim().toLowerCase();
      if (q && p.title.toLowerCase().indexOf(q) === -1 && (p.handle || '').indexOf(q) === -1) return false;
      var need1 = filter1El && filter1El.value;
      var need2 = filter2El && filter2El.value;
      if (!need1 && !need2) return true;
      var i1 = optIndex(p, cfg.f1);
      var i2 = optIndex(p, cfg.f2);
      return p.variants.some(function (v) {
        var ok1 = !need1 || (i1 > -1 && v['option' + (i1 + 1)] === need1);
        var ok2 = !need2 || (i2 > -1 && v['option' + (i2 + 1)] === need2);
        return ok1 && ok2;
      });
    }

    function priceCents(v) { return Math.round(parseFloat(v.price) * 100); }

    function render() {
      grid.innerHTML = '';
      refreshers = [];
      var shown = products.filter(matches);
      if (!shown.length) {
        grid.innerHTML = '<div class="iso-kb__empty">Nessuna fresa trovata con questi filtri.</div>';
        return;
      }
      shown.forEach(function (p) { grid.appendChild(card(p)); });
      refreshers.forEach(function (f) { f(); });
    }

    function card(p) {
      var el = document.createElement('div');
      el.className = 'iso-kb__card';

      var img = document.createElement('div');
      img.className = 'iso-kb__img';
      if (p.images && p.images.length) {
        var im = document.createElement('img');
        im.loading = 'lazy';
        im.src = p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=360';
        im.alt = p.title;
        img.appendChild(im);
      }
      el.appendChild(img);

      var name = document.createElement('p');
      name.className = 'iso-kb__name';
      name.textContent = p.title;
      el.appendChild(name);

      var price = document.createElement('p');
      price.className = 'iso-kb__price';
      el.appendChild(price);

      var opts = document.createElement('div');
      opts.className = 'iso-kb__opts';
      var selects = [];
      var optionNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
      optionNames.forEach(function (n, idx) {
        var values = [];
        p.variants.forEach(function (v) {
          var val = v['option' + (idx + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        if (values.length < 2 && optionNames.length === 1 && values[0] === 'Default Title') return;
        var s = document.createElement('select');
        s.setAttribute('aria-label', n);
        values.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v; o.textContent = n + ': ' + v;
          s.appendChild(o);
        });
        s.addEventListener('change', sync);
        opts.appendChild(s);
        selects.push(s);
      });
      el.appendChild(opts);

      var qty = document.createElement('div');
      qty.className = 'iso-kb__qty';
      var minus = document.createElement('button'); minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Diminuisci quantità');
      var input = document.createElement('input'); input.type = 'text'; input.inputMode = 'numeric'; input.value = '1'; input.setAttribute('aria-label', 'Quantità');
      var plus = document.createElement('button'); plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Aumenta quantità');
      qty.appendChild(minus); qty.appendChild(input); qty.appendChild(plus);
      el.appendChild(qty);

      var addOne = document.createElement('button');
      addOne.type = 'button';
      addOne.className = 'iso-kb__addone';
      addOne.textContent = 'Aggiungi al carrello';
      el.appendChild(addOne);

      var inKit = document.createElement('div');
      inKit.className = 'iso-kb__inkit';
      inKit.hidden = true;
      el.appendChild(inKit);

      var current = null;

      function findVariant() {
        var chosen = selects.map(function (s) { return s.value; });
        for (var i = 0; i < p.variants.length; i++) {
          var v = p.variants[i], ok = true;
          for (var j = 0; j < chosen.length; j++) {
            if (v['option' + (j + 1)] !== chosen[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return p.variants[0];
      }

      function localQty() { return Math.max(1, Math.min(999, parseInt(input.value, 10) || 1)); }

      function refreshBadge() {
        var tot = 0;
        cartItems.forEach(function (it) {
          if (it.product_id === p.id && it.properties && it.properties._iso_single) tot += it.quantity;
        });
        inKit.hidden = tot === 0;
        el.classList.toggle('in-kit', tot > 0);
        if (tot > 0) inKit.textContent = 'Nel carrello: ' + tot;
      }
      refreshers.push(refreshBadge);

      function sync() {
        current = findVariant();
        var available = current.available !== false;
        price.innerHTML = money(priceCents(current)) + ' <small>a fresa + IVA</small>' + (available ? '' : ' <small style="color:#B4232A">· esaurita</small>');
        addOne.disabled = !available;
      }

      minus.addEventListener('click', function () { input.value = Math.max(1, localQty() - 1); });
      plus.addEventListener('click', function () { input.value = Math.min(999, localQty() + 1); });
      input.addEventListener('change', function () { input.value = localQty(); });

      addOne.addEventListener('click', function () {
        if (!current || current.available === false || addOne.disabled) return;
        var q = localQty();
        var vtitle = current.title === 'Default Title' ? '' : current.title;
        addOne.disabled = true;
        var label = addOne.textContent;
        addOne.textContent = 'Aggiungo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: current.id, quantity: q, properties: { _iso_single: '1' } }] })
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw e; });
            return r.json();
          })
          .then(function () {
            toast('✓ Nel carrello: ' + p.title + (vtitle ? ' · ' + vtitle : '') + ' ×' + q);
            input.value = '1';
            return fetchCart();
          })
          .catch(function (e) {
            toast((e && e.description) ? e.description : 'Errore, riprova.');
          })
          .finally(function () {
            addOne.disabled = false;
            addOne.textContent = label;
          });
      });

      sync();
      refreshBadge();
      return el;
    }

    function updateBar() {
      var pieces = 0;
      cartItems.forEach(function (it) {
        if (it.properties && it.properties._iso_single) pieces += it.quantity;
      });
      totalEl.textContent = money(cartSingles);
      countEl.textContent = pieces + (pieces === 1 ? ' fresa nel carrello' : ' frese nel carrello');
      var pct = Math.min(100, (cartSingles / cfg.freeShip) * 100);
      fillEl.style.width = pct + '%';
      var ok = cartSingles >= cfg.min;
      goBtn.disabled = !ok;
      goBtn.classList.toggle('is-ready', ok);
      hintEl.classList.toggle('iso-kb__hint--ok', ok);
      if (pieces === 0) {
        hintEl.textContent = 'Il kit parte da ' + money(cfg.min) + ' di frese singole: scegli e aggiungi al carrello.';
      } else if (!ok) {
        hintEl.textContent = 'Aggiungi ancora ' + money(cfg.min - cartSingles) + ' di frese per completare il kit minimo (' + money(cfg.min) + ').';
      } else if (cartSingles < cfg.freeShip) {
        hintEl.textContent = 'Kit sbloccato ✓ — con altri ' + money(cfg.freeShip - cartSingles) + ' la spedizione è gratuita.';
      } else {
        hintEl.textContent = 'Kit sbloccato ✓ — spedizione gratuita inclusa.';
      }
    }

    goBtn.addEventListener('click', function () {
      if (!goBtn.disabled) window.location.href = cfg.cartUrl;
    });

    var debounce;
    if (searchEl) searchEl.addEventListener('input', function () { clearTimeout(debounce); debounce = setTimeout(render, 180); });
    if (filter1El) filter1El.addEventListener('change', render);
    if (filter2El) filter2El.addEventListener('change', render);

    updateBar();
  }

  function boot() {
    document.querySelectorAll('[data-iso-kit-builder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
